import { connect } from "react-redux";
import ViewVendorDetail from "./viewVendorDetail"; 
import { bindActionCreators } from "redux";
import {getVendorOnboardingList, approveVendor} from "services/redux/sales/vendorPortal/action";

const mapStateToProps = (state) => ({
     vendorData: state.vendorPortalReducer.vendorOnboardedList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getVendorOnboardingList,
      approveVendor
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewVendorDetail);
